<roots-page-header [toolTip]="toolTip" [title]="title" [loading]="loading">
</roots-page-header>
<!-- <roots-loading (click)="clickEvent(1)" class="col-12 col-sm-12" style="z-index: 1000; position: absolute; left: 12%; top: 40%;" [loading]="loadingIcon_1"></roots-loading> -->
<!-- <unit-loading (click)="clickEvent(2)" style="z-index: 1000; position: absolute; left: 25%; top: 40%;" [loading]="loadingIcon_2"></unit-loading> -->
<!-- <sensor-loading (click)="clickEvent(3)" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-4" style="z-index: 1000; position: absolute; left: 50%; top: 50%;" [loading]="loadingIcon_3"></sensor-loading> -->
<!-- <img class="col-12" src="../../../assets/images/admin_Background.png"/> -->
<div class="support-workspace">
<section class="support-intro">
  <span class="support-icon"><mat-icon>support_agent</mat-icon></span>
  <div><div class="support-eyebrow">Roots support</div><h2>How can we help?</h2>
    <p>Share a problem or an idea with your software administrator.</p></div>
</section>
<div class="support-guides">
  <section class="support-card">
    <span class="support-icon"><mat-icon>bug_report</mat-icon></span>
    <h2>Report a problem</h2><p>Include the page, the steps you took, and what you expected to happen.</p>
    <ul><li>Customer, Scout, or asset name</li><li>Error message and time of the issue</li><li>A screenshot, when useful</li></ul>
  </section>
  <section class="support-card">
    <span class="support-icon"><mat-icon>chat_bubble_outline</mat-icon></span>
    <h2>Share feedback</h2><p>Tell us what would make your work easier.</p>
    <ul><li>The task you are trying to complete</li><li>What could work better</li><li>Your suggested improvement</li></ul>
  </section>
</div>
<div class="support-notice"><mat-icon aria-hidden="true">info_outline</mat-icon>
  <p>Ticket submission is currently unavailable in Roots. Contact your software administrator to report a problem or share feedback.</p>
</div>
<mat-card appearance="outlined" class="legacy-support-content">
  <!-- <div *ngIf="scouts; else noData" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xxl-12" style="float: left">
    <p class="text label-header-text">
      ({{ scouts.length }}) Scouts
    </p>
  </div>
  <ng-template #noSelectedScout>
    <p class="text small-text" style="margin: 0px;">
      No Scout selected
    </p>
  </ng-template>
  <mat-select matInput placeholder="Scouts found" required name="name">
    <mat-option *ngFor="let scout of scouts" [value]="scout.name" (click)="getScout(scout)">
      <p>
        <b>{{ scout.name }} </b>
      </p>
    </mat-option>
  </mat-select> -->
</mat-card>
<!-- <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xxl-12" style="float: left;" *ngIf="selectedScout">
  <hr />
  <mat-form-field>
    <mat-label>Firmware Version</mat-label>
    <input matInput placeholder="Firmware Version" [(ngModel)]="selectedScout.firmwareVersion" disabled />
  </mat-form-field>

  <mat-form-field>
    <mat-label>Name</mat-label>
    <input matInput placeholder="Name" [(ngModel)]="selectedScout.name" disabled />
  </mat-form-field>

  <mat-form-field>
    <mat-label>Asset Name</mat-label>
    <input matInput placeholder="Asset" [(ngModel)]="selectedScout.assetName" disabled />
  </mat-form-field>

  <mat-form-field>
    <mat-label>Description</mat-label>
    <input matInput placeholder="Description" [(ngModel)]="selectedScout.description" disabled />
  </mat-form-field>

  <mat-form-field>
    <mat-label>Code</mat-label>
    <input matInput placeholder="Scout Code" [(ngModel)]="selectedScout.code" disabled />
  </mat-form-field>

  <mat-form-field>
    <mat-label>Statistics</mat-label>
    <input matInput placeholder="Statistics" [(ngModel)]="selectedScout.statistics" disabled />
  </mat-form-field>
</div>
<div *ngIf="selectedScout; else noSelectedScout" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xxl-12"
  style="float: left">
  <h3 class="text label-header-text">
    Scouts
  </h3>
</div>
<ng-template #noSelectedScout>
  <p class="text small-text" style="margin: 0px;">
    No Scouts found.
  </p>
</ng-template>
<ng-template #noData>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xxl-12" style="float: left">
    <h3 class="text label-header-text">
      <mat-icon> close </mat-icon>
      Scouts
    </h3>
    <hr />
    <p class="text small-text" style="margin: 0px;">
      No Scouts found.
    </p>
  </div>
</ng-template> -->
<app-pie (loadingEvent)="loadingEvent($event)"></app-pie>
</div>